import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './common/Logo';

const { FiMail, FiPhone, FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <div className="mb-6">
              <Logo className="h-12 w-auto" color="white" />
            </div>
            <p className="text-gray-300 mb-4">
              CREATE. IDEAS. - Professional fundraising campaign services
            </p>
            <p className="text-sm text-gray-400">
              VMC Monastery Fundraising Campaign Proposal - Page 7/7
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#FF5F1F]">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-center text-gray-300">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 mr-3 text-[#FF5F1F]" />
                <div>
                  <p>14-6 Curity Ave</p>
                  <p>Toronto, ON M4B 3L8</p>
                </div>
              </div>
              
              <div className="flex items-center text-gray-300">
                <SafeIcon icon={FiMail} className="w-5 h-5 mr-3 text-[#FF5F1F]" />
                <a href="mailto:info@creati.ca" className="hover:text-[#FF5F1F] transition-colors">
                  info@creati.ca
                </a>
              </div>
              
              <div className="flex items-center text-gray-300">
                <SafeIcon icon={FiPhone} className="w-5 h-5 mr-3 text-[#FF5F1F]" />
                <span>+1 416.731.1188</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Creatica Studio Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;